import { FC, useState } from 'react';
import clsx from 'clsx';
import { Button, Modal, Image, Text, Types } from '@marriott/mi-ui-library';
import { PreApprovedImage, PreApprovedImagesProps } from './PreApprovedImages.types';
import { StyledPreApprovedImages } from './PreApprovedImages.styles';
import { useReslinkAssociateStore } from '../../../../../store';
import { PROPERTY_IMAGE_DIMENSIONS } from '../../../../../../constants';
import { getPropertyImageUrlParams } from '../../../../../../utils';

export const PreApprovedImages: FC<PreApprovedImagesProps> = ({ label, show, onClose, onConfirm, index }) => {
  const { heading, subHeading, select, selectAriaLabel, cancel, cancelAriaLabel } = label;

  const { preApprovedPropertyImages } = useReslinkAssociateStore();
  const [selectedImage, setSelectedImage] = useState<PreApprovedImage>({ url: '', name: '' });

  const handleSelect = () => {
    const { name, url } = selectedImage;
    onConfirm({ name, url });
  };

  const onImageClick = (img: PreApprovedImage) => {
    setSelectedImage(img);
  };

  const handleClose = () => {
    setSelectedImage({ url: '', name: '' });
    onClose();
  };

  return (
    <StyledPreApprovedImages data-testid="groups-PreApprovedImages" data-component-name="m-groups-PreApprovedImages">
      <Modal
        show={show}
        popupOpenState={show}
        setPopupOpenState={handleClose}
        onClose={handleClose}
        handleBlur={true}
        disableScrollOnBody={true}
        role="dialog"
        modalId={`preApprovedImagesModal-${index + 1}`}
        labelledBy={`preApprovedImagesModal-${index + 1}`}
      >
        <Modal.Header popupHeaderOnCLoseFunc={handleClose} labelText={heading} />
        <Modal.Body className="main-section">
          <div>
            <Text element={Types.tags.paragraph} copyText={subHeading} fontSize={Types.size.large} customClass="mb-3" />
            <div className="row">
              {Object.values(preApprovedPropertyImages.propertyImages)
                .flat()
                .map(img => {
                  return (
                    <div className="col-sm-4 mb-2 px-1">
                      <div
                        className={clsx('img-container', selectedImage.url === img.url && 'selected-image')}
                        role="checkbox"
                        id={img.url}
                        aria-label={`${img.name}-container`}
                        aria-checked={selectedImage.url === img.url}
                        onKeyDown={ev => {
                          if (ev.key === 'Enter' || ev.type === 'click') {
                            onImageClick(img);
                          }
                        }}
                        tabIndex={0}
                        onClick={() => onImageClick(img)}
                      >
                        <Image
                          defaultImageURL={`${img.url}${getPropertyImageUrlParams(
                            PROPERTY_IMAGE_DIMENSIONS.REGULAR_MOBILE_IMAGE_WIDTH
                          )}`}
                          altText={img.name}
                          loading="eager"
                          customClass="pre-approved-image"
                        />
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </Modal.Body>
        <Modal.FooterGeneric
          actions={
            <>
              <Button
                className="m-button-m m-button-secondary"
                buttonCopy={cancel}
                ariaLabel={cancelAriaLabel}
                callback={handleClose}
              />

              <Button
                className="m-button-m m-button-primary"
                buttonCopy={select}
                ariaLabel={selectAriaLabel}
                callback={handleSelect}
                isDisabled={!selectedImage.url}
              />
            </>
          }
        />
      </Modal>
    </StyledPreApprovedImages>
  );
};
